/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GameType } from './GameType';
import {
    GameTypeFromJSON,
    GameTypeFromJSONTyped,
    GameTypeToJSON,
} from './GameType';

/**
 * Filters for qualifying tickets/events
 * @export
 * @interface PromotionCampaignFilters
 */
export interface PromotionCampaignFilters {
    /**
     * Only tickets issued on or before this date qualify
     * @type {Date}
     * @memberof PromotionCampaignFilters
     */
    ticketIssuedBefore?: Date;
    /**
     * Only tickets issued on or after this date qualify
     * @type {Date}
     * @memberof PromotionCampaignFilters
     */
    ticketIssuedAfter?: Date;
    /**
     * Maximum win amount in cents
     * @type {number}
     * @memberof PromotionCampaignFilters
     */
    winAmountMax?: number;
    /**
     * Minimum win amount in cents
     * @type {number}
     * @memberof PromotionCampaignFilters
     */
    winAmountMin?: number;
    /**
     * Game ID inclusion filter - must be valid GDS game UUIDs. Ticket qualifies if its game ID is in this array.
     * @type {Array<string>}
     * @memberof PromotionCampaignFilters
     */
    gameIds?: Array<string>;
    /**
     * 
     * @type {GameType}
     * @memberof PromotionCampaignFilters
     */
    gameType?: GameType;
}



/**
 * Check if a given object implements the PromotionCampaignFilters interface.
 */
export function instanceOfPromotionCampaignFilters(value: object): value is PromotionCampaignFilters {
    return true;
}

export function PromotionCampaignFiltersFromJSON(json: any): PromotionCampaignFilters {
    return PromotionCampaignFiltersFromJSONTyped(json, false);
}

export function PromotionCampaignFiltersFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionCampaignFilters {
    if (json == null) {
        return json;
    }
    return {
        
        'ticketIssuedBefore': json['ticketIssuedBefore'] == null ? undefined : (new Date(json['ticketIssuedBefore'])),
        'ticketIssuedAfter': json['ticketIssuedAfter'] == null ? undefined : (new Date(json['ticketIssuedAfter'])),
        'winAmountMax': json['winAmountMax'] == null ? undefined : json['winAmountMax'],
        'winAmountMin': json['winAmountMin'] == null ? undefined : json['winAmountMin'],
        'gameIds': json['gameIds'] == null ? undefined : json['gameIds'],
        'gameType': json['gameType'] == null ? undefined : GameTypeFromJSON(json['gameType']),
    };
}

export function PromotionCampaignFiltersToJSON(value?: PromotionCampaignFilters | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ticketIssuedBefore': value['ticketIssuedBefore'] == null ? undefined : ((value['ticketIssuedBefore']).toISOString()),
        'ticketIssuedAfter': value['ticketIssuedAfter'] == null ? undefined : ((value['ticketIssuedAfter']).toISOString()),
        'winAmountMax': value['winAmountMax'],
        'winAmountMin': value['winAmountMin'],
        'gameIds': value['gameIds'],
        'gameType': GameTypeToJSON(value['gameType']),
    };
}

